import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import LinkButton from "../common/link-button"
import { getLanguage, getTranslation } from "../../utils"

const StyledProductData = styled.div`
  position: relative;
  padding-top: 3rem;

  @media (min-width: 769px) {
    max-width: 45rem;
    margin-left: 2rem;
    padding-top: 0;
  }

  @media (min-width: 1024px) {
    > a {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
`

const StyledProductTitle = styled.h2`
  font-family: ${props => props.theme.crockpot.secondFont};
  font-weight: normal;
  font-size: 2rem;
  line-height: 2.2rem;
  text-transform: uppercase;
  margin-bottom: 0;

  @media (min-width: 769px) {
    font-size: 3rem;
    line-height: 3rem;
  }

  > div {
    margin-top: 1rem;
  }

  ${props =>
    !props.showRatings &&
    `
    margin-bottom: 2rem;
  `}
`

const StyledProductSubTitle = styled.h3`
  font-family: ${props => props.theme.crockpot.secondFont};
  font-size: 1.8rem;
  line-height: 2rem;
  color: ${props => props.theme.crockpot.text};
  font-weight: normal;
  margin-bottom: 1rem;

  @media (min-width: 769px) {
    font-size: 2.5rem;
    line-height: 3rem;
    margin-bottom: 2.5rem;
  }
`

const StyledProductDescription = styled.div`
  overflow-y: auto;
  max-height: 35rem;
  font-size: 1.1rem;
  line-height: 1.5rem;

  @media (min-width: 769px) {
    font-size: 1.8rem;
    line-height: 2.2rem;
  }

  @media (min-width: 1025px) {
    height: 40rem;
  }

  ul {
    margin-left: 1.8rem;
  }
`

const ProductRating = styled.div`
  padding-bottom: 2rem;
`

const ProductData = ({ product = {}, showRatings = false }) => {
  if (!product) return null

  const linkClick = () => {
    window.BV.pixel.trackConversion({
      type: "WhereToBuy",
    })
  }

  return (
    <StyledProductData>
      <StyledProductTitle showRatings={showRatings}>
        {product.productTitle}
        {showRatings && product.bvProductId && !product.productSubTitle && (
          <ProductRating
            data-bv-show="rating_summary"
            data-bv-product-id={product.bvProductId}
          />
        )}
      </StyledProductTitle>
      {product.productSubTitle && (
        <StyledProductSubTitle>
          {product.productSubTitle}
          <br />
          {product.bvProductId && (
            <ProductRating
              data-bv-show="rating_summary"
              data-bv-product-id={product.bvProductId}
            />
          )}
        </StyledProductSubTitle>
      )}
      {product.productDescription && (
        <StyledProductDescription data-testid="product-decription">
          {documentToReactComponents(
            JSON.parse(product.productDescription.raw),
          )}
        </StyledProductDescription>
      )}
      <LinkButton
        link={`${getLanguage()}/${getTranslation("where-to-buy-link")}`}
        title={
          <button
            onClick={() => {
              linkClick()
            }}
          >
            {getTranslation("where-to-buy")}
          </button>
        }
        isAlt={true}
        hasChild={true}
      />
    </StyledProductData>
  )
}

ProductData.propTypes = {
  product: PropTypes.object,
  showRatings: PropTypes.bool,
}

export default ProductData
